import { all, call, fork, put, takeEvery } from 'redux-saga/effects'
import { WizardPageActionTypes } from './types'

import { fetchSuccessModels } from './actions'
import { fetchSuccessInfotaiments } from './actions'
import { fetchSuccessProductionPeriods } from './actions'
import { fetchSuccessVinCheckResult } from './actions'
import { fetchFailureVinCheckResult } from './actions'

import { callApi } from '../../utils/api'

const API_ENDPOINT = 'api/Filter/'


function* handleFetchModels(action: any) {
    try {
        let filter = action.payload as SkodaAuto.Marvin.ServiceAvailability.Web.App.Models.Filters.DataFilter;

        let params = '?';
        
        if (filter.ImporterBid) {
            params = params + '&ImporterBid=' + filter.ImporterBid;
        }
        if (filter.Culture) {
            params = params + '&Culture=' + filter.Culture;
        }

        const res: SkodaAuto.Marvin.ServiceAvailability.Web.App.Models.Data.ModelFamilyModel[] = yield call(callApi, 'get', API_ENDPOINT + 'GetModels' + params)
        yield put(fetchSuccessModels(res))
    }
    catch (err) {

    }
}

//get data from controller
function* handleFetchInfotaiments(action: any) {
    try {
        let filter = action.payload as SkodaAuto.Marvin.ServiceAvailability.Web.App.Models.Filters.DataFilter;

        let params = '?';

        if (filter.CountryCode) {
            params = params + '&CountryCode=' + filter.CountryCode;
        }
        if (filter.FamilyCode) {
            params = params + '&FamilyCode=' + filter.FamilyCode;
        }
        if (filter.InfotainmentCode) {
            params = params + '&InfotainmentCode=' + filter.InfotainmentCode;
        }
        if (filter.ProductionFromCode) {
            params = params + '&ProductionFromCode=' + filter.ProductionFromCode;
        }
        if (filter.ProductionToCode) {
            params = params + '&ProductionToCode=' + filter.ProductionToCode;
        }
        if (filter.ImporterBid) {
            params = params + '&ImporterBid=' + filter.ImporterBid;
        }
        if (filter.Culture) {
            params = params + '&Culture=' + filter.Culture;
        }

        const res: SkodaAuto.Marvin.ServiceAvailability.Web.App.Models.Data.InfotaimentModel[] = yield call(callApi, 'get', API_ENDPOINT + 'GetInfotaiments' + params)
        yield put(fetchSuccessInfotaiments(res))
    }
    catch (err) {

    }
}

function* handleFetchProductionPeriods(action: any) {
    try {
        let filter = action.payload as SkodaAuto.Marvin.ServiceAvailability.Web.App.Models.Filters.DataFilter;

        let params = '?';

        if (filter.CountryCode) {
            params = params + '&CountryCode=' + filter.CountryCode;
        }
        if (filter.FamilyCode) {
            params = params + '&FamilyCode=' + filter.FamilyCode;
        }
        if (filter.InfotainmentCode) {
            params = params + '&InfotainmentCode=' + filter.InfotainmentCode;
        }
        if (filter.ProductionFromCode) {
            params = params + '&ProductionFromCode=' + filter.ProductionFromCode;
        }
        if (filter.ProductionToCode) {
            params = params + '&ProductionToCode=' + filter.ProductionToCode;
        }
        if (filter.ImporterBid) {
            params = params + '&ImporterBid=' + filter.ImporterBid;
        }
        if (filter.Culture) {
            params = params + '&Culture=' + filter.Culture;
        }

        const res: SkodaAuto.Marvin.ServiceAvailability.Web.App.Models.Data.ProductionIntervalModel[] = yield call(callApi, 'get', API_ENDPOINT + 'GetProductionPeriods' + params)
        yield put(fetchSuccessProductionPeriods(res))
    }
    catch (err) {

    }
}

function* handleFetchForVin(action: any) {
    try {
        let filter = action.payload.filter as SkodaAuto.Marvin.ServiceAvailability.Web.App.Models.Filters.DataFilter;

        let params = '?';

        if (filter.CountryCode) {
            params = params + '&CountryCode=' + filter.CountryCode;
        }
        if (filter.ImporterBid) {
            params = params + '&ImporterBid=' + filter.ImporterBid;
        }
        if (filter.Culture) {
            params = params + '&Culture=' + filter.Culture;
        }
        if (filter.EnteredVin) {
            params = params + '&VinCode=' + filter.EnteredVin;
        }

        // To call async functions, use redux-saga's `call()`.
        const res: SkodaAuto.Marvin.ServiceAvailability.Web.App.Models.Data.VinCheckResultModel = yield call(callApi, 'get', 'api/Availability/GetVinCheckResult' + params)
        yield put(fetchSuccessVinCheckResult(res))
    }
    catch (err) {
        yield put(fetchFailureVinCheckResult(err))
    }
}

function* watchFetchRequestModels() {
    yield takeEvery(WizardPageActionTypes.FETCH_REQUEST_Models, handleFetchModels);
}

//create sagas from every handleFetch method
function* watchFetchRequestInfotaiments() {
    yield takeEvery(WizardPageActionTypes.FETCH_REQUEST_Infotaiments, handleFetchInfotaiments);
}

function* watchFetchRequestProductionPeriods() {
    yield takeEvery(WizardPageActionTypes.FETCH_REQUEST_ProductionPeriods, handleFetchProductionPeriods);
}

function* watchFetchForVinRequest() {
    yield takeEvery(WizardPageActionTypes.FETCH_REQUEST_VinCheckResult, handleFetchForVin)
}

//definition of WizardPageSaga
function* wizardPageSaga() {
    yield all([fork(watchFetchRequestModels),fork(watchFetchRequestInfotaiments), fork(watchFetchRequestProductionPeriods), fork(watchFetchForVinRequest)]);
}

export default wizardPageSaga
